export default __webpack_public_path__ + "static/media/stripe_screenshot.ce5c42b4.png";